<script type="text/ecmascript-6">
    import DesignerQuestionHardwareSpyhole from "./DesignerQuestionHardwareSpyhole.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareSpyhole,
            SynsealQuestion,
        ],
        computed: {
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            }
        }
    }
</script>
